export default "__VITE_ASSET__EnTnaPgA__"